module.exports = __webpack_public_path__ + "img/login_text.cd0c37dc.png";